import { format } from 'date-fns';

import { NBReportRes } from '@apis/orval/model';

import round from '@utils/round';

import { KeyMetricsNbProps } from './KeyMetrics';

export class KeyMetricsNbAdapter {
	value: NBReportRes;

	constructor(obj: NBReportRes) {
		this.value = obj;
	}

	get averageDailyVisitors() {
		const averageDailyVisitersValue = this.value?.core_metrics?.avg_daily_visitor;
		return averageDailyVisitersValue
			? `${round(averageDailyVisitersValue, 'down')} 명`
			: '- 명';
	}

	get averageTotalVisitors() {
		const averageTotalVisitorsValue = this.value?.core_metrics?.total_visitor;
		return averageTotalVisitorsValue
			? `${round(averageTotalVisitorsValue, 'down')} 명`
			: '- 명';
	}

	get postAverageViews() {
		const postAverageViewsValue = this.value?.core_metrics?.avg_daily_view;
		return postAverageViewsValue ? `${round(postAverageViewsValue, 'down')} 회` : '- 회';
	}

	get updatedAt() {
		const updatedTime = this.value?.updated_time;
		return updatedTime ? format(new Date(updatedTime), 'yyyy. MM. dd') : '-';
	}

	adapt(): {
		updatedAt?: string;
		props?: KeyMetricsNbProps;
	} {
		return {
			updatedAt: this.updatedAt,
			props: {
				averageDailyVisitors: this.averageDailyVisitors,
				averageTotalVisitors: this.averageTotalVisitors,
				postAverageViews: this.postAverageViews,
			},
		};
	}
}
